import React from "react"
import ReactDOM from "react-dom"
import reportWebVitals from "./reportWebVitals"
import "./index.css"
import BookingConfigurator from "./booking-configurator"
import StandaloneInventoryCard from "./standalone-inventory-card"
import BookingAgent from "./booking-agent"
import Map from "./map"
import CartPreview from "./cart-preview"
import Login from "./login"
import Signup from "./signup"
import Profile from "./profile"
import UserProfileNavItem from "./user-profile-nav-item"
import { update } from "@intercom/messenger-js-sdk"

console.log("version 1")

// Wrapper component to ensure all widgets are properly scoped
const WidgetWrapper = ({ children }) => (
  <div className="flexday-widget">{children}</div>
)

let fallbackLocation
fetch(`https://pro.ip-api.com/json?key=${process.env.REACT_APP_IP_API_API_KEY}`)
  .then((response) => response.json())
  .then((data) => {
    const supportedAreas = {
      CA: {
        ON: {
          lat: 43.644379939764086,
          lng: -79.39865381355503,
        },
        QC: {
          lat: 45.50347963768571,
          lng: -73.56843374638021,
        },
        AB: {
          lat: 51.044743785977936,
          lng: -114.06401208919131,
        },
        BC: {
          lat: 49.283301543004384,
          lng: -123.117195944881,
        },
      },
      US: {
        GA: {
          lat: 33.78653104249158,
          lng: -84.38240317233726,
        },
        NY: {
          lat: 40.759864838618434,
          lng: -73.98043482397334,
        },
        MA: {
          lat: 42.35901680539551,
          lng: -71.05981268528137,
        },
        NC: {
          lat: 35.78238221306003,
          lng: -78.63218547143912,
        },
      },
    }

    if (supportedAreas[data.countryCode]) {
      fallbackLocation = supportedAreas[data.countryCode][data.region]
    }
  })
  .catch(() => {})
  .finally(() => {
    renderMap(fallbackLocation)
  })

function renderMap(fallbackLocation) {
  document.querySelectorAll(".flexday-workspace-browser").forEach((el) => {
    const lat = el.getAttribute("data-latitude") || ""
    const lng = el.getAttribute("data-longitude") || ""
    let defaultLocation =
      lat && lng
        ? { lat: parseFloat(lat), lng: parseFloat(lng) }
        : fallbackLocation

    ReactDOM.render(
      <WidgetWrapper>
        <Map defaultLocation={defaultLocation} />
      </WidgetWrapper>,
      el
    )
  })
}

document.querySelectorAll(".flexday-inventory-card").forEach((el) => {
  const id = el.getAttribute("data-id")
  const inventoryType = el.getAttribute("data-inventory-type")
  ReactDOM.render(
    <WidgetWrapper>
      <StandaloneInventoryCard id={id} inventoryType={inventoryType} />
    </WidgetWrapper>,
    el
  )
})

document.querySelectorAll(".flexday-booking-agent").forEach((el) => {
  const autoJoin = el.getAttribute("data-auto-join") === "true"
  ReactDOM.render(
    <WidgetWrapper>
      <BookingAgent settingsId={el.dataset.settings} autoJoin={autoJoin} />
    </WidgetWrapper>,
    el
  )
})

// Add event-based mounting for BookingAgent
document.addEventListener("flexday-mount-booking-agent", (event) => {
  const el = event.target
  if (el && el.dataset.settings) {
    const autoJoin = el.getAttribute("data-auto-join") === "true"
    ReactDOM.render(
      <WidgetWrapper>
        <BookingAgent settingsId={el.dataset.settings} autoJoin={autoJoin} />
      </WidgetWrapper>,
      el
    )
  }
})

document.querySelectorAll(".flexday-booking-configurator").forEach((el) => {
  const renderComponent = () => {
    const inventoryPageId = el.getAttribute("data-inventory-page")
    const currency = el.getAttribute("data-currency") || "CAD"

    ReactDOM.render(
      <WidgetWrapper>
        <BookingConfigurator
          inventoryPageId={inventoryPageId}
          currency={currency}
        />
      </WidgetWrapper>,
      el
    )
  }

  renderComponent()

  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "data-currency"
      ) {
        ReactDOM.unmountComponentAtNode(el)
        renderComponent()
        break
      }
    }
  })

  observer.observe(el, { attributes: true })
})

document.querySelectorAll(".flexday-cart-preview").forEach((el) => {
  const renderCartPreview = () => {
    const currency = el.getAttribute("data-currency") || "CAD"
    console.debug({ cartCurrency: currency })

    ReactDOM.render(
      <WidgetWrapper>
        <CartPreview currency={currency} />
      </WidgetWrapper>,
      el
    )
  }

  renderCartPreview()

  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "data-currency"
      ) {
        // Unmount the existing component
        ReactDOM.unmountComponentAtNode(el)
        renderCartPreview()
        break
      }
    }
  })

  observer.observe(el, { attributes: true })
})

document.querySelectorAll(".flexday-login").forEach((el) => {
  const loginUrl = el.getAttribute("data-log-in-url")
  const successUrl = el.getAttribute("data-success-url")

  ReactDOM.render(
    <WidgetWrapper>
      <Login
        loginUrl={loginUrl}
        onError={(error) => {
          console.error({ error })
        }}
        onSuccess={async (user, redirectUrl) => {
          const { email, displayName } = user
          await update({ email, name: displayName })

          setTimeout(() => {
            window.location.href = redirectUrl ?? successUrl
          }, 1000)
        }}
      />
    </WidgetWrapper>,
    el
  )
})

document.querySelectorAll(".flexday-signup").forEach((el) => {
  const createAccountUrl = el.getAttribute("data-create-account-url")
  const successUrl = el.getAttribute("data-success-url")

  ReactDOM.render(
    <WidgetWrapper>
      <Signup
        createAccountUrl={createAccountUrl}
        onError={(error) => {
          console.error({ error })
        }}
        onSuccess={async (user, redirectUrl) => {
          const { email, displayName } = user
          await update({ email, name: displayName })

          setTimeout(() => {
            window.location.href = redirectUrl ?? successUrl
          }, 1000)
        }}
      />
    </WidgetWrapper>,
    el
  )
})

document.querySelectorAll(".flexday-user-profile-nav-item").forEach((el) => {
  const cartUrl = el.getAttribute("data-cart-url")
  const loginUrl = el.getAttribute("data-log-in-url")
  const createAccountUrl = el.getAttribute("data-create-account-url")
  const loggedOutUrl = el.getAttribute("data-logged-out-url")

  ReactDOM.render(
    <WidgetWrapper>
      <UserProfileNavItem
        cartUrl={cartUrl}
        loginUrl={loginUrl}
        createAccountUrl={createAccountUrl}
        loggedOutUrl={loggedOutUrl}
      />
    </WidgetWrapper>,
    el
  )
})

document.querySelectorAll(".flexday-user-profile").forEach((el) => {
  const profileUrl = el.getAttribute("data-profile-url")

  ReactDOM.render(
    <WidgetWrapper>
      <Profile profileUrl={profileUrl} />
    </WidgetWrapper>,
    el
  )
})

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
